import styled from 'styled-components';

const CouponModalStyled = styled.div`
  width: 900px;
  .coupon-name-wrap {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: baseline;
    gap: 14px;
  }
  .table-header {
    width: 100%;
  }
  .coupon-list {
    width: 100%;
    padding: 20px 32px 24px;
    .table-content {
      margin: 0;
    }
  }
  .modal-btn-wrap {
    /* margin-right: ${(props) => props.theme.spacing(3)}; */
    display: flex;
    flex-direction: row;
    float: right;
    /* margin-bottom:35px; */
    gap: 6px;
    /* margin-top: ${(props) => props.theme.spacing(23 / 8)}; */

    /* margin-bottom: ${(props) => props.theme.spacing(24 / 8)}; */
    justify-content: flex-end;
    padding: 12px 0;
  }
`;

export default CouponModalStyled;
